import { SortableHeadCell, TextCell } from 'components/tables/cells';
import { createColumnHelper } from '@tanstack/table-core';
import { TextColumnProps } from 'components/tables/columnTypes';
import { ProviderAccessLog } from '../types';
import { toDefaultDateFormatOrNotAvailable } from 'utils/dateUtils';

const columnHelper = createColumnHelper<ProviderAccessLog>();

export const userLevelTableColumns = {
	providerCode: (overrideProps?: TextColumnProps<ProviderAccessLog>) =>
		columnHelper.accessor((row) => row.providerCode, {
			id: 'providerCode',
			enableSorting: true,
			header: ({ header }) => (
				<SortableHeadCell
					text="Provider Code"
					header={header}
					{...overrideProps?.headCellProps}
				/>
			),
			cell: (info) => (
				<TextCell
					text={info.getValue()}
					{...overrideProps?.cellProps}
				/>
			),
			...overrideProps?.columnDefProps,
		}),
	firstName: (overrideProps?: TextColumnProps<ProviderAccessLog>) =>
		columnHelper.accessor((row) => row.firstName, {
			id: 'firstName',
			enableSorting: true,
			header: ({ header }) => (
				<SortableHeadCell
					text="First Name"
					header={header}
					{...overrideProps?.headCellProps}
				/>
			),
			cell: (info) => (
				<TextCell
					text={info.getValue()}
					{...overrideProps?.cellProps}
				/>
			),
			...overrideProps?.columnDefProps,
		}),
	lastName: (overrideProps?: TextColumnProps<ProviderAccessLog>) =>
		columnHelper.accessor((row) => row.lastName, {
			id: 'lastName',
			enableSorting: true,
			header: ({ header }) => (
				<SortableHeadCell
					text="Last Name"
					header={header}
					{...overrideProps?.headCellProps}
				/>
			),
			cell: (info) => (
				<TextCell
					text={info.getValue()}
					{...overrideProps?.cellProps}
				/>
			),
			...overrideProps?.columnDefProps,
		}),
	email: (overrideProps?: TextColumnProps<ProviderAccessLog>) =>
		columnHelper.accessor((row) => row.email, {
			id: 'email',
			enableSorting: true,
			header: ({ header }) => (
				<SortableHeadCell
					text="Email"
					header={header}
					{...overrideProps?.headCellProps}
				/>
			),
			cell: (info) => (
				<TextCell
					text={info.getValue()}
					{...overrideProps?.cellProps}
				/>
			),
			...overrideProps?.columnDefProps,
		}),
	companyId: (overrideProps?: TextColumnProps<ProviderAccessLog>) =>
		columnHelper.accessor((row) => `${row.companyId}`, {
			id: 'companyId',
			enableSorting: true,
			header: ({ header }) => (
				<SortableHeadCell
					text="Company ID"
					header={header}
					{...overrideProps?.headCellProps}
				/>
			),
			cell: (info) => (
				<TextCell
					text={info.getValue()}
					{...overrideProps?.cellProps}
				/>
			),
			...overrideProps?.columnDefProps,
		}),
	companyName: (overrideProps?: TextColumnProps<ProviderAccessLog>) =>
		columnHelper.accessor((row) => row.companyName, {
			id: 'companyName',
			enableSorting: true,
			header: ({ header }) => (
				<SortableHeadCell
					text="Company Name"
					header={header}
					{...overrideProps?.headCellProps}
				/>
			),
			cell: (info) => (
				<TextCell
					text={info.getValue()}
					{...overrideProps?.cellProps}
				/>
			),
			...overrideProps?.columnDefProps,
		}),
	subscriptionType: (overrideProps?: TextColumnProps<ProviderAccessLog>) =>
		columnHelper.accessor((row) => row.subscriptionType, {
			id: 'subscriptionType',
			enableSorting: true,
			header: ({ header }) => (
				<SortableHeadCell
					text="Subscription Type"
					header={header}
					{...overrideProps?.headCellProps}
				/>
			),
			cell: (info) => (
				<TextCell
					text={info.getValue()}
					{...overrideProps?.cellProps}
				/>
			),
			...overrideProps?.columnDefProps,
		}),
	grantedAccess: (overrideProps?: TextColumnProps<ProviderAccessLog>) =>
		columnHelper.accessor((row) => row.grantedAccess, {
			id: 'grantedAccess',
			enableSorting: true,
			header: ({ header }) => (
				<SortableHeadCell
					text="Granted Access"
					header={header}
					{...overrideProps?.headCellProps}
				/>
			),
			cell: (info) => (
				<TextCell
					text={toDefaultDateFormatOrNotAvailable(
						info.getValue(),
						'n/a',
						'DD MM YYYY',
					)}
					{...overrideProps?.cellProps}
				/>
			),
			...overrideProps?.columnDefProps,
		}),
	lostAccess: (overrideProps?: TextColumnProps<ProviderAccessLog>) =>
		columnHelper.accessor((row) => row.lostAccess || '-', {
			id: 'lostAccess',
			enableSorting: true,
			header: ({ header }) => (
				<SortableHeadCell
					text="Lost Access"
					header={header}
					{...overrideProps?.headCellProps}
				/>
			),
			cell: (info) => (
				<TextCell
					text={toDefaultDateFormatOrNotAvailable(
						info.getValue(),
						'Active',
						'DD MM YYYY',
					)}
					{...overrideProps?.cellProps}
				/>
			),
			...overrideProps?.columnDefProps,
		}),
	realtime: (overrideProps?: TextColumnProps<ProviderAccessLog>) =>
		columnHelper.accessor((row) => `${row.realtime}`, {
			id: 'realtime',
			enableSorting: true,
			header: ({ header }) => (
				<SortableHeadCell
					text="Realtime"
					header={header}
					{...overrideProps?.headCellProps}
				/>
			),
			cell: (info) => (
				<TextCell
					text={info.getValue() == 'true' ? 'Yes' : ''}
					{...overrideProps?.cellProps}
				/>
			),
			...overrideProps?.columnDefProps,
		}),
};
